import React from "react";

const PreConditionForOtherHeader = () => {
  return (
    <>
      <div className="login-pagination">
        <ul>
          <li className="active">
            <a href="#">step 1</a>
          </li>
          <li className="active">
            <a href="#">step 2</a>
          </li>
          <li className="">
            <a href="#">step 3</a>
          </li>
        </ul>
        <p className="text-center">
          Step <span className="fw-bold">2 of 3</span>
        </p>
      </div>
    </>
  );
};

export default PreConditionForOtherHeader;
